var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionOfflineNavigationColored({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6Z",
    fill: "url(#paint0_linear_2330_1937)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H9V17H7V11H5L8 7L11 11ZM19 11H17V17H15V11H13L16 7L19 11Z",
    fill: "#FFC107"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2330_1937",
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6523D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5714CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionOfflineNavigationColored);
export default __webpack_public_path__ + "static/media/ic_action_offline_navigation_colored.072d392ed90f2e49318a3671e89ca6ec.svg";
export { ForwardRef as ReactComponent };